<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-12 px-0">
                        <h1 class="m-0 text-dark"><i class="nav-icon fas fa-users-cog"></i> Prestadores <small>Formulário de Cadastro</small></h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-12 px-0">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active"><i class="nav-icon fas fa-users-cog"></i> Prestadores</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline">
                    <div class="card-header">
                        <h3 class="card-title"><i class="fad fa-arrow-circle-right"></i> Dados do Prestador</h3>
                    </div>
                    <form id="form1" class="form-horizontal">
                        <div class="card-body">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="nome" class="col-form-label">Nome</label>
                                    <div class="col-sm-10 px-0">
                                        <input type="text" class="form-control validate[required]" id="nome" name="nome" v-model="entity.nome" size="50" maxlength="150" placeholder="Nome" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="rg" class="col-form-label">Apelido</label>
                                    <div class="col-sm-12 px-0">
                                        <input type="text" class="form-control " id="apelido" name="apelido" v-model="entity.apelido" size="12" maxlength="12" placeholder="Apelido" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="sexo" class="col-form-label">Sexo</label>
                                    <div class="col-sm-4 px-0">
                                        <select-editor v-model="entity.sexo" data-placeholder="Escolha o Sexo">
                                            <option value="M">Masculino</option>
                                            <option value="F">Feminino</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="cpf" class="col-form-label">CPF</label>
                                    <div class="col-sm-12 px-0">
                                        <input type="text" class="form-control validate[required]" id="cpf" name="cpf" v-model="entity.cpf" size="15" maxlength="15" placeholder="CPF" data-inputmask="'mask': '999.999.999-99'"/>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="rg" class="col-form-label">RG</label>
                                    <div class="col-sm-12 px-0">
                                        <input type="text" class="form-control " id="rg" name="rg" v-model="entity.rg" size="12" maxlength="12" placeholder="RG" data-inputmask="'mask': '99.999.999-9'"/>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="data_nascimento" class="col-form-label">Data de Nascimento</label>
                                    <div class="col-sm-4 px-0">
                                        <date-editor v-model="entity.data_nascimento" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="email" class="col-form-label">E-mail</label>
                                    <div class="col-sm-8 px-0">
                                        <input type="text" class="form-control " id="email" name="email" v-model="entity.email" size="50" maxlength="150" placeholder="E-mail" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="telefone" class="col-form-label">Telefone</label>
                                    <div class="col-sm-4 px-0">
                                        <input type="text" class="form-control " id="telefone" name="telefone" v-model="entity.telefone" size="20" maxlength="20" placeholder="Telefone" />
                                    </div>
                                </div>                                
                                <div class="form-group col-md-6">
                                    <label for="endereco" class="col-form-label">Endereço</label>
                                    <div class="col-sm-10 px-0">
                                        <textarea class="form-control " id="endereco" name="endereco" v-model="entity.endereco"  placeholder="Endereço" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="creci_crea_cau" class="col-form-label">CRECI / CREA / CAU</label>
                                    <div class="col-sm-12 px-0">
                                        <input type="text" class="form-control " id="creci_crea_cau" name="creci_crea_cau" v-model="entity.creci_crea_cau" size="50" maxlength="150" placeholder="CRECI / CREA / CAU" />
                                    </div>
                                </div>
                            </div>
                            <div class="card-body-title">
                                <h3><i class="fad fa-arrow-circle-right"></i> Dados de Empresa</h3>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="departamento" class="col-form-label">Departamento</label>
                                    <div class="col-sm-12 px-0">
                                        <select-editor v-model="entity.departamento" data-placeholder="Escolha o Departamento">
                                            <option>ADMINISTRATIVO</option>
                                            <option>APROVAÇÕES CEF</option>
                                            <option>APROVAÇÕES E LEGALIZAÇÕES</option>
                                            <option>ÁREA TÉCNICA (PROJ., ORÇ. e PLANEJ.)</option>
                                            <option>BI</option>
                                            <option>CAC</option>
                                            <option>CEF</option>
                                            <option>CENTRAL DE LANCTO DE NOTAS</option>
                                            <option>CLIENTE</option>
                                            <option>CONSELHO DE ADMINISTRAÇÃO</option>
                                            <option>CRÉDITO IMOBILIÁRIO</option>
                                            <option>ENGENHARIA DE VALOR</option>
                                            <option>FILIAL RJ</option>
                                            <option>FINANCEIRO</option>
                                            <option>INCORPORAÇÃO</option>
                                            <option>MARKETING</option>
                                            <option>NOVOS NEGÓCIOS</option>
                                            <option>NOVOS NEGÓCIOS / PROJETO</option>
                                            <option>OBRAS</option>
                                            <option>OBRAS - ADM</option>
                                            <option>OBRAS / ÁREA TÉCNICA</option>
                                            <option>PLANEJAMENTO FINANCEIRO</option>
                                            <option>PRESIDÊNCIA</option>
                                            <option>PROJETO</option>
                                            <option>PROJETOS EXECUTIVOS</option>
                                            <option>QMAT</option>
                                            <option>RH</option>
                                            <option>RH/DP</option>
                                            <option>RH/RS</option>
                                            <option>SECRETARIA DE VENDAS</option>
                                            <option>SQS</option>
                                            <option>SUPRIMENTOS</option>
                                            <option>SUSTENTABILIDADE</option>
                                            <option>TESOURARIA</option>
                                            <option>TI</option>
                                            <option>VENDAS</option>
                                            <option>VENDAS / MARKETING</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="funcao" class="col-form-label">Função</label>
                                    <div class="col-sm-12 px-0">                                        
                                        <select-editor v-model="entity.funcao" data-placeholder="Escolha a Função">
                                            <option>1/2 OFICIAL DE ELÉTRICA</option>
                                            <option>ADMINISTRATIVO DE OBRAS</option>
                                            <option>ADMINISTRATIVO DE VENDAS</option>
                                            <option>AGENTE DE AGENDAMENTOS</option>
                                            <option>AGENTE DE ATENDIMENTO</option>
                                            <option>AGENTE DE ATENDIMENTO JR.</option>
                                            <option>AGENTE DE ATENDIMENTO SR.</option>
                                            <option>AGENTE DE RELACIONAMENTO</option>
                                            <option>ALMOXARIFE</option>
                                            <option>ANALISTA ADM./FACILITIES</option>
                                            <option>ANALISTA ADMINISTRATIVO</option>
                                            <option>ANALISTA COMERCIAL</option>
                                            <option>ANALISTA CONTABIL</option>
                                            <option>ANALISTA DE APROVAÇÕES CEF</option>
                                            <option>ANALISTA DE APROVAÇÕES E LEGALIZAÇÕES</option>
                                            <option>ANALISTA DE ARQUITETURA</option>
                                            <option>ANALISTA DE ASSINATURA CEF</option>
                                            <option>ANALISTA DE ASSIST. TÉCNICA</option>
                                            <option>ANALISTA DE CONCILIACAO BANCARIA</option>
                                            <option>ANALISTA DE CONTAS A PAGAR</option>
                                            <option>ANALISTA DE CONTAS A RECEBER</option>
                                            <option>ANALISTA DE CONTRATOS</option>
                                            <option>ANALISTA DE CONTRATOS CEF SR</option>
                                            <option>ANALISTA DE CONTROLADORIA</option>
                                            <option>ANALISTA DE CRÉDITO E REPASSE</option>
                                            <option>ANALISTA DE CRÉDITO E REPASSE SR.</option>
                                            <option>ANALISTA DE CREDITO IMOBILIARIO</option>
                                            <option>ANALISTA DE CRÉDITO IMOBILIARIO</option>
                                            <option>ANALISTA DE DOC. DE SEGURANCA DO TRABALHO</option>
                                            <option>ANALISTA DE DP</option>
                                            <option>ANALISTA DE ENGENHARIA</option>
                                            <option>ANALISTA DE FACILITIES</option>
                                            <option>ANALISTA DE INCORPORACAO</option>
                                            <option>ANALISTA DE INFRAESTRUTURA</option>
                                            <option>ANALISTA DE LEGALIZAÇÃO</option>
                                            <option>ANALISTA DE MARKETING</option>
                                            <option>ANALISTA DE MARKETING DIGITAL</option>
                                            <option>ANALISTA DE MARKETING EM CX</option>
                                            <option>ANALISTA DE MARKETING ONLINE</option>
                                            <option>ANALISTA DE MIDIAS</option>
                                            <option>ANALISTA DE MÍDIAS SOCIAIS</option>
                                            <option>ANALISTA DE NOVOS NEGÓCIOS</option>
                                            <option>ANALISTA DE ORÇAMENTOS</option>
                                            <option>ANALISTA DE PERFORMANCE DIGITAL</option>
                                            <option>ANALISTA DE PLANEJAMENTO</option>
                                            <option>ANALISTA DE PLANEJAMENTO FINANCEIRO</option>
                                            <option>ANALISTA DE PROJETOS</option>
                                            <option>ANALISTA DE PROJETOS EXECUTIVOS</option>
                                            <option>ANALISTA DE PROJETOS EXECUTIVOS JR</option>
                                            <option>ANALISTA DE QUALIDADE</option>
                                            <option>ANALISTA DE QUALIDADE/ASSIST. TÉCNICA</option>
                                            <option>ANALISTA DE RECRUTAMENTO</option>
                                            <option>ANALISTA DE RECRUTAMENTO E SELEÇÃO</option>
                                            <option>ANALISTA DE REGISTRO DE CONTRATOS CEF</option>
                                            <option>ANALISTA DE REGULARIZAÇÃO IMOBILIÁRIA</option>
                                            <option>ANALISTA DE REPASSE</option>
                                            <option>ANALISTA DE RETIFICACAO IMOBILIARIA</option>
                                            <option>ANALISTA DE RH</option>
                                            <option>ANALISTA DE SUPORTE DE SISTEMAS</option>
                                            <option>ANALISTA DE SUPORTE JR</option>
                                            <option>ANALISTA DE SUPORTE PLENO</option>
                                            <option>ANALISTA DE SUPORTE SR</option>
                                            <option>ANALISTA DE SUPRIMENTOS JR</option>
                                            <option>ANALISTA DE TI</option>
                                            <option>ANALISTA FINANCEIRO</option>
                                            <option>ANALISTA FISCAL</option>
                                            <option>ANALISTA FISCAL SENIOR</option>
                                            <option>ANALISTA JURÍDICO</option>
                                            <option>ARQUITETA</option>
                                            <option>ARQUITETA PROJETISTA</option>
                                            <option>ARQUITETO/LEGALIZAÇÃO</option>
                                            <option>ASSISTENTE ADMINISTRATIVO</option>
                                            <option>ASSISTENTE ADMINISTRATIVO DE OBRAS</option>
                                            <option>ASSISTENTE COMERCIAL</option>
                                            <option>ASSISTENTE DE APROVAÇÕES E LEGALIZAÇÕES</option>
                                            <option>ASSISTENTE DE ARQUITETURA</option>
                                            <option>ASSISTENTE DE ATENDIMENTO</option>
                                            <option>ASSISTENTE DE CONCILIACAO BANCARIA</option>
                                            <option>ASSISTENTE DE CONTAS A PAGAR</option>
                                            <option>ASSISTENTE DE CONTAS A RECEBER</option>
                                            <option>ASSISTENTE DE CONTRATOS CEF</option>
                                            <option>ASSISTENTE DE CONTROLADORIA</option>
                                            <option>ASSISTENTE DE CONTROLE E CONTRATOS CEF</option>
                                            <option>ASSISTENTE DE DESIGN</option>
                                            <option>ASSISTENTE DE DP</option>
                                            <option>ASSISTENTE DE ENGENHARIA</option>
                                            <option>ASSISTENTE DE FACILITIES</option>
                                            <option>ASSISTENTE DE INCORPORAÇÃO</option>
                                            <option>ASSISTENTE DE MARKETING</option>
                                            <option>ASSISTENTE DE NOVOS NEGÓCIOS</option>
                                            <option>ASSISTENTE DE PLANEJAMENTO</option>
                                            <option>ASSISTENTE DE QUALIDADE</option>
                                            <option>ASSISTENTE DE RECRUTAMENTO E SELEÇÃO</option>
                                            <option>ASSISTENTE DE REGISTRO DE CONTRATOS CEF</option>
                                            <option>ASSISTENTE DE REPASSE</option>
                                            <option>ASSISTENTE DE SUPRIMENTOS</option>
                                            <option>ASSISTENTE DE TI</option>
                                            <option>ASSISTENTE FINANCEIRO</option>
                                            <option>ASSISTENTE FISCAL</option>
                                            <option>ASSISTENTE JURÍDICO I</option>
                                            <option>ASSITENTE DE ARQUITETURA</option>
                                            <option>ASSITENTE DE CONTAS A PAGAR</option>
                                            <option>AUX DE PLANEJAMENTO E CONTROLE</option>
                                            <option>AUX. DE ENGENHARIA</option>
                                            <option>AUXILIAR ADMINISTRATIVO</option>
                                            <option>AUXILIAR DE ALMOXARIFADO</option>
                                            <option>AUXILIAR DE APROVAÇÕES CEF</option>
                                            <option>AUXILIAR DE ASSISTENCIA TECNICA</option>
                                            <option>AUXILIAR DE ENGENHARIA </option>
                                            <option>AUXILIAR DE SERVIÇOS GERAIS</option>
                                            <option>CARPINTEIRO</option>
                                            <option>CFO</option>
                                            <option>COMPRADORA JUNIOR</option>
                                            <option>CONSELHEIRO</option>
                                            <option>CONSULTOR DE VENDAS</option>
                                            <option>CONTROLLER</option>
                                            <option>COORD. DE APROVAÇÕES CEF</option>
                                            <option>COORDENADOR CONTÁBIL</option>
                                            <option>COORDENADOR DE ASSINATURA CEF</option>
                                            <option>COORDENADOR DE CONTAS A RECEBER</option>
                                            <option>COORDENADOR DE CONTRATOS</option>
                                            <option>COORDENADOR DE CONTROLADORIA DE OBRA</option>
                                            <option>COORDENADOR DE CONTROLE</option>
                                            <option>COORDENADOR DE ENGENHARIA</option>
                                            <option>COORDENADOR DE MARKETING</option>
                                            <option>COORDENADOR DE OBRAS</option>
                                            <option>COORDENADOR DE ORÇAMENTOS</option>
                                            <option>COORDENADOR DE PARCERIAS</option>
                                            <option>COORDENADOR DE PLANEJAMENTO</option>
                                            <option>COORDENADOR DE PLANEJAMENTO FINANEIRO</option>
                                            <option>COORDENADOR DE PROJETOS</option>
                                            <option>COORDENADOR DE SUPRIMENTOS</option>
                                            <option>COORDENADOR DE TI</option>
                                            <option>COORDENADOR DO CAC</option>
                                            <option>COORDENADOR FISCAL</option>
                                            <option>COORDENADOR PROJETISTA</option>
                                            <option>COORDENADOR(A) CONTABIL</option>
                                            <option>COORDENADOR(A) DE ANALISE E PLANEJ. DE MARKETING</option>
                                            <option>COORDENADOR(A) DE APROVAÇÕES CEF</option>
                                            <option>COORDENADOR(A) DE ARQUITETURA</option>
                                            <option>COORDENADOR(A) DE ATENDIMENTO</option>
                                            <option>COORDENADOR(A) DE ATENDIMENTO / ANTECIPAÇÕES</option>
                                            <option>COORDENADOR(A) DE BUSINESS INTELLIGENCE</option>
                                            <option>COORDENADOR(A) DE COBRANÇAS</option>
                                            <option>COORDENADOR(A) DE CONTAS A RECEBER</option>
                                            <option>COORDENADOR(A) DE CONTRATOS</option>
                                            <option>COORDENADOR(A) DE CONTROLADORIA</option>
                                            <option>COORDENADOR(A) DE CREDITO IMOBILIARIO</option>
                                            <option>COORDENADOR(A) DE CRIACAO</option>
                                            <option>COORDENADOR(A) DE CS E REPUTACAO DIGITAL</option>
                                            <option>COORDENADOR(A) DE DENSENVOLVIMENTO DE VENDAS</option>
                                            <option>COORDENADOR(A) DE DP</option>
                                            <option>COORDENADOR(A) DE NOVOS NEGÓCIOS</option>
                                            <option>COORDENADOR(A) DE PARCEIRA</option>
                                            <option>COORDENADOR(A) DE PARCERIA</option>
                                            <option>COORDENADOR(A) DE PLANEJAMENTO FINANCEIRO</option>
                                            <option>COORDENADOR(A) DE PROJETOS</option>
                                            <option>COORDENADOR(A) DE REGULARIZAÇÕES</option>
                                            <option>COORDENADOR(A) DE REPASSE</option>
                                            <option>COORDENADOR(A) DE SEC. VENDAS</option>
                                            <option>COORDENADOR(A) DE SUPRIMENTOS</option>
                                            <option>COORDENADOR(A) FISCAL</option>
                                            <option>COORDENADOR(A) JURIDICA</option>
                                            <option>COORDENADOR(A) QUALIDADE/ASSIST. TÉCNICA</option>
                                            <option>COORDENADORA CENTRAL DE ATENDIMENTO AO CLIENTE</option>
                                            <option>COORDENADORA DE ASSINATURA CEF</option>
                                            <option>COORDENADORA DE CONTAS A PAGAR</option>
                                            <option>COORDENADORA DE PROJETOS EXECUTIVOS</option>
                                            <option>COORDENADORA DE REGISTROS</option>
                                            <option>COORDENADORA DE SUPRIMENTOS</option>
                                            <option>DESENHISTA CADISTA</option>
                                            <option>DESIGNER</option>
                                            <option>DESIGNER GRAFICO</option>
                                            <option>DESIGNER GRAFICO JR</option>
                                            <option>DIRETOR ADMINISTRATIVO</option>
                                            <option>DIRETOR DE ENGENHARIA</option>
                                            <option>DIRETOR DE NOVOS NEGÓCIOS</option>
                                            <option>DIRETOR DE OBRAS</option>
                                            <option>DIRETOR DE VENDAS</option>
                                            <option>DIRETOR DE VENDAS E MARKETING</option>
                                            <option>DIRETOR FINANCEIRO E CONSELHEIRO</option>
                                            <option>DIRETOR REGIONAL</option>
                                            <option>ELETRICISTA</option>
                                            <option>ENCANADOR</option>
                                            <option>ENCARREGADO ADMINISTRATIVO</option>
                                            <option>ENCARREGADO DE FORMA</option>
                                            <option>ENCARREGADO DE INSTALACOES</option>
                                            <option>ENCARREGADO DE OBRAS</option>
                                            <option>ENGENHEIRA DE PLANEJAMENTO E CUSTOS</option>
                                            <option>ENGENHEIRA RESIDENTE</option>
                                            <option>ENGENHEIRO CIVIL</option>
                                            <option>ENGENHEIRO DE OBRAS</option>
                                            <option>ENGENHEIRO DE SEGURANÇA DO TRABALHO</option>
                                            <option>ENGENHEIRO RESIDENTE</option>
                                            <option>ENGENHEIRO(A) DE ORÇAMENTOS</option>
                                            <option>ENGENHEIRO(A) DE QUALIDADE</option>
                                            <option>ENGENHEIRO(A) DE SEGURANÇA DO TRABALHO</option>
                                            <option>ENGENHEIRO(A) RESIDENTE</option>
                                            <option>ESTAGIÁRIA DE ARQUITETURA</option>
                                            <option>ESTAGIÁRIA DE DP</option>
                                            <option>ESTAGIÁRIA DE ENGENHARIA</option>
                                            <option>ESTAGIÁRIA EM ARQUITETURA</option>
                                            <option>ESTAGIÁRIA EM DIREITO</option>
                                            <option>ESTAGIÁRIO DE ARQUITETURA</option>
                                            <option>ESTAGIÁRIO DE ENGENHARIA</option>
                                            <option>ESTAGIÁRIO DE PROJETOS</option>
                                            <option>ESTAGIÁRIO DE SUPRIMENTOS</option>
                                            <option>FINANCEIRO/ADMINISTRATIVO</option>
                                            <option>GERENTE CAC</option>
                                            <option>GERENTE CONTABIL</option>
                                            <option>GERENTE DE APROVAÇÕES</option>
                                            <option>GERENTE DE ATENDIMENTO</option>
                                            <option>GERENTE DE CLIENTE</option>
                                            <option>GERENTE DE CREDITO E REPASSE</option>
                                            <option>GERENTE DE ENGENHARIA</option>
                                            <option>GERENTE DE ENGENHARIA DE VALOR</option>
                                            <option>GERENTE DE MARKETING</option>
                                            <option>GERENTE DE NOVOS NEGÓCIOS</option>
                                            <option>GERENTE DE OPERAÇÕES</option>
                                            <option>GERENTE DE PARCERIAS</option>
                                            <option>GERENTE DE PLANEJAMENTO ESTRATÉGICO</option>
                                            <option>GERENTE DE PRODUTO E LEGALIZAÇÃO</option>
                                            <option>GERENTE DE PROJETOS</option>
                                            <option>GERENTE DE RH</option>
                                            <option>GERENTE DE SECRETARIA DE VENDAS</option>
                                            <option>GERENTE DE SUPRIMENTOS</option>
                                            <option>GERENTE DE SUSTENTABILIDADE</option>
                                            <option>GERENTE DE TI</option>
                                            <option>GERENTE DE VENDAS</option>
                                            <option>GERENTE DE VENDAS GOLD</option>
                                            <option>GERENTE FINANCEIRO</option>
                                            <option>GERENTE GERAL DE ENGENHARIA</option>
                                            <option>GERENTE TÉCNICO</option>
                                            <option>GESTOR DE VENDAS</option>
                                            <option>LIDER DE CUSTOMER SUCCESS</option>
                                            <option>MEIO OFICIAL ELETRICA</option>
                                            <option>MESTE DE OBRAS</option>
                                            <option>MESTRE DE OBRAS</option>
                                            <option>MESTRE DE OBRAS I</option>
                                            <option>MESTRE DE OBRAS II</option>
                                            <option>MESTRE DE OBRAS III</option>
                                            <option>OFFICE BOY</option>
                                            <option>OFICIAL DE MANUTENCAO II</option>
                                            <option>OFICIAL DE MANUTENCAO III</option>
                                            <option>OFICIAL E MANUTENCAO II</option>
                                            <option>PEDREIRO</option>
                                            <option>PINTOR</option>
                                            <option>RECEPCIONISTA</option>
                                            <option>RECEPCIONISTA LIDER</option>
                                            <option>SECRETÁRIA EXECUTIVA</option>
                                            <option>SERVENTE DE OBRAS</option>
                                            <option>SUPERINTENDENTE DE VENDAS</option>
                                            <option>SUPERVISOR ADMINISTRATIVO DE OBRAS</option>
                                            <option>SUPERVISOR DE ATENDIMENTO</option>
                                            <option>SUPERVISOR DE CONCILIACAO BANCARIA</option>
                                            <option>SUPERVISOR(A) DE SEGURANCA DO TRABALHO</option>
                                            <option>SUPERVISORA DE CONTAS A PAGAR</option>
                                            <option>TECNICA DE SEGURANÇA DO TRABALHO</option>
                                            <option>TECNICO DE EDFICAÇÕES</option>
                                            <option>TÉCNICO DE SEGURANÇA DO TRABALHO</option>
                                            <option>TECNICO(A) DE SEGURANÇA DO TRABALHO</option>
                                            <option>TRAINEE EM ENGENHARIA CIVIL</option>
                                            <option>TREINADOR CORPORATIVO</option>
                                            <option>VIDEOMAKER</option>
                                            <option>WEB DESIGNER</option>
                                            <option>WEB DESIGNER JR</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="coordenador" class="col-form-label">Coordenador</label>
                                    <div class="col-sm-8 px-0">
                                        <select-editor ajax="/api/prestador/select-prestador" :params="{ status_prestador: true }" data-placeholder="Selecione o Coordenador" v-model="entity.coordenador">
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="gerente" class="col-form-label">Gerente</label>
                                    <div class="col-sm-8 px-0">
                                        <select-editor ajax="/api/prestador/select-prestador" :params="{ status_prestador: true }" data-placeholder="Selecione o Gerente" v-model="entity.gerente">
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="superintendente" class="col-form-label">Superintendente</label>
                                    <div class="col-sm-8 px-0">
                                        <select-editor ajax="/api/prestador/select-prestador" :params="{ status_prestador: true }" data-placeholder="Selecione o Superintendente" v-model="entity.superintendente">
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="diretor" class="col-form-label">Diretor</label>
                                    <div class="col-sm-8 px-0">
                                        <select-editor v-model="entity.diretor" data-placeholder="Escolha o Diretor">
                                            <option>ANDRÉ A.</option>
                                            <option>BRUNO</option>
                                            <option>CLAUDIO</option>
                                            <option>EVERSON</option>
                                            <option>FELIPE</option>
                                            <option>FERNANDO</option>
                                            <option>GEORGE</option>
                                            <option>HENRIQUE</option>
                                            <option>LEANDRO</option>
                                            <option>MARCUS</option>
                                            <option>VIEIRA GIULIASSE</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="data_entrada" class="col-form-label">Data de Entrada</label>
                                    <div class="col-sm-4 px-0">
                                        <date-editor v-model="entity.data_entrada" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="data_saida" class="col-form-label">Data de Saída</label>
                                    <div class="col-sm-4 px-0">
                                        <date-editor v-model="entity.data_saida" />
                                    </div>
                                </div>
                            </div>
                            <div class="card-body-title">
                                <h3><i class="fad fa-arrow-circle-right"></i> Dados Bancários</h3>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="pix" class="col-form-label">PIX</label>
                                    <div class="col-sm-8 px-0">
                                        <input type="text" class="form-control " id="pix" name="pix" v-model="entity.pix" size="50" maxlength="150" placeholder="PIX" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="banco" class="col-form-label">Banco </label>
                                    <div class="col-sm-12 px-0">
                                        <select-editor v-model="entity.banco" data-placeholder="Escolha o Banco">
                                            <option value="654">654 - A.J. RENNER S.A..</option>
                                            <option value="246">246 - ABC-BRASIL S.A..</option>
                                            <option value="213">213 - ARBI S.A..</option>
                                            <option value="19">019 - AZTECA DO BRASIL S.A..</option>
                                            <option value="25">025 - BANCO ALFA.</option>
                                            <option value="241">241 - Banco Classico S.A.</option>
                                            <option value="83">083 - BANCO DA CHINA BRASIL S.A..</option>
                                            <option value="300">300 - BANCO DE LA NACION ARGENTINA.</option>
                                            <option value="495">495 - BANCO DE LA PROVINCIA DE BUENOS AIRES.</option>
                                            <option value="494">494 - BANCO DE LA REPUBLICA ORIENTAL DEL URUGUAY.</option>
                                            <option value="1">001 - BANCO DO BRASIL.</option>
                                            <option value="37">037 - BANCO DO ESTADO DO PARÁ S.A.</option>
                                            <option value="456">456 - BANCO TOKYO MITSUBISH UFJ BRASIL S.A.</option>
                                            <option value="370">370 - BANCO WESTLB DO BRASIL.</option>
                                            <option value="756">756 - BANCOOB.</option>
                                            <option value="756">756 - BANCOOB.</option>
                                            <option value="47">047 - BANESE.</option>
                                            <option value="33">033 - BANESPA.</option>
                                            <option value="21">021 - BANESTES.</option>
                                            <option value="719">719 - BANIF-BANCO INTERNACIONAL DO FUNCHAL (BRASIL) S.A.</option>
                                            <option value="755">755 - BANK OF AMERICA MERRILL LYNCH BANCO MULTIPLO S.A..</option>
                                            <option value="41">041 - BANRISUL.</option>
                                            <option value="740">740 - BARCLAYS S.A..</option>
                                            <option value="3">003 - BASA.</option>
                                            <option value="107">107 - BBM S.A.</option>
                                            <option value="81">081 - BBN BANCO BRASILEIRO DE NEGOCIOS S.A.</option>
                                            <option value="250">250 - BCV - BANCO DE CREDITO E VAREJO S.A.</option>
                                            <option value="36">036 - BEM.</option>
                                            <option value="122">122 - BERJ S.A.</option>
                                            <option value="78">078 - BES INVESTIMENTO DO BRASIL SA - BANCO DE INVESTIM..</option>
                                            <option value="739">739 - BGN S.A..</option>
                                            <option value="320">320 - BIC BANCO.</option>
                                            <option value="96">096 - BM&F DE SERV. DE LIQUIDACAO E CUSTODIA S.A.</option>
                                            <option value="394">394 - BMC S.A..</option>
                                            <option value="318">318 - BMG S.A..</option>
                                            <option value="4">004 - BNB.</option>
                                            <option value="752">752 - BNP PARIBAS BRASIL S.A.</option>
                                            <option value="17">017 - BNY MELLON S.A..</option>
                                            <option value="248">248 - BOA VISTA INTERATLANTICO S.A.</option>
                                            <option value="218">218 - BONSUCESSO S.A..</option>
                                            <option value="69">069 - BPN BRASIL BANCO MULTIPLO S.A.</option>
                                            <option value="65">065 - BRACCE S.A..</option>
                                            <option value="237">237 - BRADESCO.</option>
                                            <option value="225">225 - BRASCAN S.A..</option>
                                            <option value="125">125 - BRASIL PLURAL S.A. BANCO MULTIPLO.</option>
                                            <option value="70">070 - BRB.</option>
                                            <option value="92">092 - BRICKELL S A CREDITO, FINANCIAMENTO E INVESTIMENTO.</option>
                                            <option value="208">208 - BTG PACTUAL S.A..</option>
                                            <option value="263">263 - CACIQUE S.A..</option>
                                            <option value="104">104 - CAIXA ECON. FEDERAL.</option>
                                            <option value="473">473 - CAIXA GERAL - BRASIL S.A..</option>
                                            <option value="412">412 - CAPITAL S.A..</option>
                                            <option value="40">040 - CARGILL S.A.</option>
                                            <option value="112">112 - CC UNICRED BRASIL CENTRAL.</option>
                                            <option value="84">084 - CC UNIPRIME NORTE DO PARANA.</option>
                                            <option value="114">114 - CECOOPES-CENTRAL DAS COOP DE ECON E CRED MUTUO DO.</option>
                                            <option value="85">085 - CECREDI.</option>
                                            <option value="266">266 - CEDULA S.A..</option>
                                            <option value="233">233 - CIFRA S.A..</option>
                                            <option value="745">745 - CITIBANK.</option>
                                            <option value="477">477 - Citibank N.A..</option>
                                            <option value="90">090 - COOPERATIVA CENTRAL DE CREDITO DO ESTADO DE SP.</option>
                                            <option value="97">097 - COOPERATIVA CENTRAL DE CREDITO NOROESTE BRASILEIRO.</option>
                                            <option value="89">089 - COOPERATIVA DE CREDITO RURAL DA REGIAO DA MOGIANA.</option>
                                            <option value="75">075 - CR2 S.A.</option>
                                            <option value="98">098 - CREDIALIANCA COOPERATIVA DE CREDITO RURAL.</option>
                                            <option value="222">222 - CREDIT AGRICOLE BRASIL S.A..</option>
                                            <option value="505">505 - CREDIT SUISSE (BRASIL) S.A..</option>
                                            <option value="707">707 - DAYCOVAL.</option>
                                            <option value="487">487 - DEUTSCHE BANK S. A. - BANCO ALEMAO.</option>
                                            <option value="214">214 - DIBENS S.A..</option>
                                            <option value="265">265 - FATOR S.A..</option>
                                            <option value="224">224 - FIBRA.</option>
                                            <option value="626">626 - FICSA S.A..</option>
                                            <option value="121">121 - GERADOR S.A..</option>
                                            <option value="612">612 - GUANABARA S.A..</option>
                                            <option value="62">062 - HIPERCARD BANCO MULTIPLO S.A.</option>
                                            <option value="399">399 - HSBC.</option>
                                            <option value="63">063 - IBI.</option>
                                            <option value="604">604 - INDUSTRIAL DO BRASIL S. A..</option>
                                            <option value="653">653 - INDUSVAL S.A..</option>
                                            <option value="492">492 - ING BANK N.V..</option>
                                            <option value="630">630 - INTERCAP S.A..</option>
                                            <option value="77">077 - INTERMEDIUM S.A..</option>
                                            <option value="249">249 - Investcred Unibanco.</option>
                                            <option value="341">341 - ITAÚ.</option>
                                            <option value="652">652 - ITAU HOLDING FINANCEIRA S.A.</option>
                                            <option value="184">184 - Itaú-BBA.</option>
                                            <option value="74">074 - J. SAFRA S.A..</option>
                                            <option value="376">376 - J.P. MORGAN S.A..</option>
                                            <option value="217">217 - JOHN DEERE S.A..</option>
                                            <option value="488">488 - JPMORGAN CHASE BANK.</option>
                                            <option value="76">076 - KDB DO BRASIL S.A.</option>
                                            <option value="757">757 - KEB DO BRASIL S.A..</option>
                                            <option value="600">600 - Luso Brasileiro.</option>
                                            <option value="243">243 - MAXIMA S.A..</option>
                                            <option value="389">389 - MERCANTIL DO BRASIL.</option>
                                            <option value="746">746 - MODAL S.A..</option>
                                            <option value="66">066 - MORGAN STANLEY DEAN WITTER S.A.</option>
                                            <option value="14">014 - NATIXIS BRASIL S.A. - BANCO MòLTIPLO.</option>
                                            <option value="753">753 - NBC BANK BRASIL S.A.- BANCO MULTIPLO.</option>
                                            <option value="45">045 - OPPORTUNITY S.A..</option>
                                            <option value="79">079 - ORIGINAL DO AGRONEGOCIO S.A..</option>
                                            <option value="212">212 - ORIGINAL S.A..</option>
                                            <option value="623">623 - PANAMERICANO.</option>
                                            <option value="254">254 - PARANA BANCO S.A..</option>
                                            <option value="611">611 - PAULISTA.</option>
                                            <option value="613">613 - PECUNIA S.A..</option>
                                            <option value="94">094 - PETRA S.A..</option>
                                            <option value="643">643 - PINE S.A..</option>
                                            <option value="735">735 - POTTENCIAL S.A..</option>
                                            <option value="747">747 - RABOBANK INTERNATIONAL BRASIL S.A..</option>
                                            <option value="88">088 - RANDON S.A..</option>
                                            <option value="633">633 - RENDIMENTO S.A..</option>
                                            <option value="741">741 - RIBEIRÃO PRETO.</option>
                                            <option value="120">120 - RODOBENS S.A.</option>
                                            <option value="453">453 - RURAL.</option>
                                            <option value="72">072 - RURAL MAIS S.A.</option>
                                            <option value="422">422 - SAFRA.</option>
                                            <option value="751">751 - SCOTIABANK BRASIL S.A BANCO MULTIPLO.</option>
                                            <option value="743">743 - SEMEAR S.A..</option>
                                            <option value="748">748 - SICREDI.</option>
                                            <option value="749">749 - SIMPLES S.A..</option>
                                            <option value="366">366 - SOCIETE GENERALE BRASIL S.A.</option>
                                            <option value="637">637 - SOFISA S.A..</option>
                                            <option value="464">464 - SUMITOMO MITSUI BRASILEIRO S.A..</option>
                                            <option value="82">082 - TOPAZIO S.A..</option>
                                            <option value="634">634 - Triangulo.</option>
                                            <option value="230">230 - UNICARD BANCO MULTIPLO S.A.</option>
                                            <option value="91">091 - UNICRED CENTRAL RS - CENTRAL DE COOP ECON CRED MUT.</option>
                                            <option value="87">087 - UNICRED CENTRAL SANTA CATARINA.</option>
                                            <option value="99">099 - UNIPRIME CENTRAL - CENTRAL INT DE COOP DE CRED LTD.</option>
                                            <option value="655">655 - VOTORANTIM.</option>
                                            <option value="610">610 - VR S.A..</option>
                                            <option value="119">119 - WESTERN UNION DO BRASIL S.A..</option>
                                            <option value="124">124 - WOORI BANK DO BRASIL S.A.</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="agencia" class="col-form-label">Agência</label>
                                    <div class="col-sm-4 px-0">
                                        <input type="text" class="form-control " id="agencia" name="agencia" v-model="entity.agencia" size="20" maxlength="20" placeholder="Agência" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="conta" class="col-form-label">Conta</label>
                                    <div class="col-sm-4 px-0">
                                        <input type="text" class="form-control " id="conta" name="conta" v-model="entity.conta" size="20" maxlength="20" placeholder="Conta" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="tipo_conta" class="col-form-label">Tipo Conta</label>
                                    <div class="col-sm-4 px-0">                                        
                                        <select-editor v-model="entity.tipo_conta" data-placeholder="Escolha o Tipo de Conta">
                                            <option>CORRENTE</option>
                                            <option>PJ</option>
                                            <option>POUPANÇA</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="titular_conta" class="col-form-label">Titular da Conta</label>
                                    <div class="col-sm-4 px-0">
                                        <select-editor v-model="entity.titular_conta" data-placeholder="Escolha o Titular da Conta">
                                            <option>PF</option>
                                            <option>PJ</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="conta" class="col-form-label">Cadastro Bancos</label>
                                    <div class="col-sm-8 px-0">
                                        <input type="text" class="form-control " id="cadastro_bancos" name="cadastro_bancos" v-model="entity.cadastro_bancos" size="20" maxlength="20" placeholder="Cadastro Bancos" />
                                    </div>
                                </div>
                            </div>
                            <div class="card-body-title">
                                <h3><i class="fad fa-arrow-circle-right"></i> Dados da Contratação</h3>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="modalidade_contratacao" class="col-form-label">Modalidade Contratação</label>
                                    <div class="col-sm-12 px-0">
                                        <select-editor v-model="entity.modalidade_contratacao" data-placeholder="Escolha a Modalidade Contratação">
                                            <option>Associado</option>
                                            <option>Autonomo Associado</option>
                                            <option>CLT</option>
                                            <option>Corretor(a) Associado(a)</option>
                                            <option>Estágio</option>
                                            <option>PF</option>
                                            <option>PJ</option>
                                            <option>PJ </option>
                                            <option>Pró-labore</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="tem_empresa" class="col-form-label">Tem Empresa?</label>
                                    <div class="col-sm-10 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="tem_empresa" data-icheck="green" v-model="entity.tem_empresa" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="tem_empresa" data-icheck="red" v-model="entity.tem_empresa" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="cnpj" class="col-form-label">CNPJ</label>
                                    <div class="col-sm-4 px-0">
                                        <input type="text" class="form-control " id="cnpj" name="cnpj" v-model="entity.cnpj" size="20" maxlength="20" placeholder="CNPJ" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="nome_empresa" class="col-form-label">Empresa</label>
                                    <div class="col-sm-12 px-0">
                                        <input type="text" class="form-control " id="nome_empresa" name="nome_empresa" v-model="entity.nome_empresa" size="50" maxlength="255" placeholder="Empresa" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="tipo_empresa" class="col-form-label">Tipo de Empresa</label>
                                    <div class="col-sm-4 px-0">
                                        <select-editor v-model="entity.tipo_empresa" data-placeholder="Escolha o Tipo de Empresa">
                                            <option>EIRELI</option>
                                            <option>EPP</option>
                                            <option>Ltda.</option>
                                            <option>ME</option>
                                            <option>MEI</option>
                                            <option>MEI </option>
                                            <option>MRI</option>
                                            <option>N/A</option>
                                            <option>PJ </option>
                                            <option>SIMEI</option>
                                            <option>Simples Nacional</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="data_ativacao" class="col-form-label">Data de Ativação</label>
                                    <div class="col-sm-4 px-0">
                                        <date-editor v-model="entity.data_ativacao" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="atividade_principal" class="col-form-label">Atividade Principal</label>
                                    <div class="col-sm-8 px-0">
                                        <input type="text" class="form-control " id="atividade_principal" name="atividade_principal" v-model="entity.atividade_principal" size="50" maxlength="255" placeholder="Atividade Principal" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="atividades_secundarias" class="col-form-label">Atividades Secundarias</label>
                                    <div class="col-sm-8 px-0">
                                        <input type="text" class="form-control " id="atividades_secundarias" name="atividades_secundarias" v-model="entity.atividades_secundarias" size="50" maxlength="500" placeholder="Atividades Secundarias" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="emitindo_nfe" class="col-form-label">Emitindo NF-e?</label>
                                    <div class="col-sm-10 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="emitindo_nfe" data-icheck="green" v-model="entity.emitindo_nfe" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="emitindo_nfe" data-icheck="red" v-model="entity.emitindo_nfe" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="nfe_pendente" class="col-form-label">NF-e Pendente?</label>
                                    <div class="col-sm-10 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="nfe_pendente" data-icheck="green" v-model="entity.nfe_pendente" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="nfe_pendente" data-icheck="red" v-model="entity.nfe_pendente" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="contrato_assinado" class="col-form-label">Contrato Assinado?</label>
                                    <div class="col-sm-12 px-0">
                                        <input type="text" class="form-control " id="contrato_assinado" name="contrato_assinado" v-model="entity.contrato_assinado" size="50" maxlength="50" placeholder="Contrato Assinado" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="data_assinatura_contrato" class="col-form-label">Data de Assinatura do Contrato</label>
                                    <div class="col-sm-4 px-0">
                                        <date-editor v-model="entity.data_assinatura_contrato" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="declaracao" class="col-form-label">Declaração?</label>
                                    <div class="col-sm-12 px-0">
                                        <input type="text" class="form-control " id="declaracao" name="declaracao" v-model="entity.declaracao" size="20" maxlength="20" placeholder="Declaração?" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="distrato_assinado_prestador" class="col-form-label">Distrato Assinado Prestador?</label>
                                    <div class="col-sm-10 px-0">
                                        <input type="text" class="form-control " id="distrato_assinado_prestador" name="distrato_assinado_prestador" v-model="entity.distrato_assinado_prestador" size="1" maxlength="1" placeholder="Distrato Assinado Prestador?" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="arquivo_fisico" class="col-form-label">Arquivo Fisico</label>
                                    <div class="col-sm-10 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="arquivo_fisico" data-icheck="green" v-model="entity.arquivo_fisico" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="arquivo_fisico" data-icheck="red" v-model="entity.arquivo_fisico" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="arquivo_digital" class="col-form-label">Arquivo Digital</label>
                                    <div class="col-sm-10 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="arquivo_digital" data-icheck="green" v-model="entity.arquivo_digital" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="arquivo_digital" data-icheck="red" v-model="entity.arquivo_digital" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="vigencia" class="col-form-label">Vigência</label>
                                    <div class="col-sm-4 px-0">
                                        <date-editor v-model="entity.vigencia" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="observacao" class="col-form-label">Observação</label>
                                    <div class="col-sm-10 px-0">
                                        <textarea class="form-control " id="observacao" name="observacao" v-model="entity.observacao"  placeholder="Observação" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="pesquisa_trt" class="col-form-label">Pesquisa TRT</label>
                                    <div class="col-sm-12 px-0">
                                        <select-editor v-model="entity.pesquisa_trt" data-placeholder="Escolha a Pesquisa TRT">
                                            <option>CHECAR</option>
                                            <option>NEGATIVO</option>
                                            <option>POSITIVO</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="entrevista" class="col-form-label">Entrevista</label>
                                    <div class="col-sm-12 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="entrevista" data-icheck="green" v-model="entity.entrevista" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="entrevista" data-icheck="red" v-model="entity.entrevista" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="retorno_pesquisa" class="col-form-label">Retorno da Pesquisa</label>
                                    <div class="col-sm-4 px-0">
                                        <date-editor v-model="entity.retorno_pesquisa" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="codigo_uau_pf" class="col-form-label">Código UAU PF</label>
                                    <div class="col-sm-4 px-0">
                                        <input type="text" class="form-control " id="codigo_uau_pf" name="codigo_uau_pf" v-model="entity.codigo_uau_pf" size="20" maxlength="20" placeholder="Código UAU PF" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="codigo_uau_pj" class="col-form-label">Código UAU PJ</label>
                                    <div class="col-sm-4 px-0">
                                        <input type="text" class="form-control " id="codigo_uau_pj" name="codigo_uau_pj" v-model="entity.codigo_uau_pj" size="20" maxlength="20" placeholder="Código UAU PJ" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="comprovante_documento" class="col-form-label">RG e CPF ou CNH</label>
                                    <div class="col-sm-12 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="comprovante_documento" data-icheck="green" v-model="entity.comprovante_documento" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="comprovante_documento" data-icheck="red" v-model="entity.comprovante_documento" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="comprovante_estado_civil" class="col-form-label">Comprov. Est. Civil</label>
                                    <div class="col-sm-4 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="comprovante_estado_civil" data-icheck="green" v-model="entity.comprovante_estado_civil" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="comprovante_estado_civil" data-icheck="red" v-model="entity.comprovante_estado_civil" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="comprovante_endereco" class="col-form-label">Comprov. Endereço</label>
                                    <div class="col-sm-4 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="comprovante_endereco" data-icheck="green" v-model="entity.comprovante_endereco" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="comprovante_endereco" data-icheck="red" v-model="entity.comprovante_endereco" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="cartao_cnpj" class="col-form-label">Cartão CNPJ</label>
                                    <div class="col-sm-4 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="cartao_cnpj" data-icheck="green" v-model="entity.cartao_cnpj" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="cartao_cnpj" data-icheck="red" v-model="entity.cartao_cnpj" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="cartao_bancario" class="col-form-label">Cartão Bancário</label>
                                    <div class="col-sm-4 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="cartao_bancario" data-icheck="green" v-model="entity.cartao_bancario" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="cartao_bancario" data-icheck="red" v-model="entity.cartao_bancario" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="cv_ctps" class="col-form-label">CV ou CTPS</label>
                                    <div class="col-sm-12 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="cv_ctps" data-icheck="green" v-model="entity.cv_ctps" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="cv_ctps" data-icheck="red" v-model="entity.cv_ctps" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="comprovante_escolaridade" class="col-form-label">Comprov. Escolaridade</label>
                                    <div class="col-sm-12 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="comprovante_escolaridade" data-icheck="green" v-model="entity.comprovante_escolaridade" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="comprovante_escolaridade" data-icheck="red" v-model="entity.comprovante_escolaridade" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="comprovante_creci_crea_cau" class="col-form-label">CRECI / CREA / CAU2 / CRA</label>
                                    <div class="col-sm-12 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="comprovante_creci_crea_cau" data-icheck="green" v-model="entity.comprovante_creci_crea_cau" v-bind:value="true" />
                                                Sim
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="comprovante_creci_crea_cau" data-icheck="red" v-model="entity.comprovante_creci_crea_cau" v-bind:value="false" />
                                                Não
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="para_validacoes" class="col-form-label">[AF] - [Q]</label>
                                    <div class="col-sm-4 px-0">
                                        <input type="text" class="form-control " id="af_q" name="af_q" v-model="entity.af_q" size="50" maxlength="255" placeholder="[AF] - [Q]" />
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="obra_mc" class="col-form-label">Obra (MC)</label>
                                    <div class="col-sm-10 px-0">
                                        <input type="text" class="form-control " id="obra_mc" name="obra_mc" v-model="entity.obra_mc" size="50" maxlength="100" placeholder="Obra Mc" />
                                    </div>
                                </div>
                            </div>
                            <div class="card-body-title">
                                <h3><i class="fad fa-arrow-circle-right"></i> Status</h3>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <div class="col-sm-10 px-0">
                                        <div class="radio">
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="status_prestador" data-icheck="green" v-model="entity.status_prestador" v-bind:value="true" />
                                                Ativo
                                            </label>
                                            <label class="form-radio form-check-label form-icon">
                                                <input type="radio" name="status_prestador" data-icheck="red" v-model="entity.status_prestador" v-bind:value="false" />
                                                Inativo
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="card-footer">
                        <button type="button" v-if="this.$route.params.id == 0" v-on:click="insertEntity" class="btn btn-success btn-social" :class="{ 'disabled': !($store.state.authUser.isAdmin || $store.state.authUser.permissoes?.prestadores?.create) }"> <i class="fas fa-check"></i> Inserir</button>
                        <button type="button" v-if="this.$route.params.id != 0" v-on:click="updateEntity" class="btn btn-info btn-social" :class="{ 'disabled': !($store.state.authUser.isAdmin || $store.state.authUser.permissoes?.prestadores?.write) }"> <i class="fas fa-pencil-alt"></i> Alterar</button>
                        <button type="button" v-if="this.$route.params.id != 0" v-on:click="deleteEntity" class="btn btn-danger btn-social" :class="{ 'disabled': !($store.state.authUser.isAdmin || $store.state.authUser.permissoes?.prestadores?.delete) }"> <i class="fas fa-times"></i> Excluir</button>
                        <button type="button" v-on:click="back" class="btn btn-default btn-social"><i class="fas fa-history"></i> Voltar</button>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>
        <!-- /.content -->
    </div>
</template>

<script>
import PrestadorController from "@/controllers/prestador.controller";

export default {
    data: function () {
        return {
            entity: {}
        };
    },
    mounted() {
        this.$validator.validate("#form1");
        const id = parseInt(this.$route.params.id, 10);
        this.loadEntity(id);
        $(":input").inputmask();
    },
    methods: {
        loadEntity: function (id) {

            if (id === 0)
                return;

            PrestadorController.getById(id)
                .then(response => {
                    this.entity = response.data.result;
                });
        },
        insertEntity: function (event) {
            if (!this.$validator.isValid("#form1"))
            return;

            event.target.disabled = true;

            let vm = this;

            PrestadorController.insert(vm.entity)
                .then(response => {
                    if (!response.data.success) {
                        vm.$toastr.error(response.data.error, 'Erro!', {
                            timeOut: 8000,
                            onHidden: function () {
                                event.target.disabled = false;
                            }
                        });
                        return;
                    }

                    vm.$toastr.success("Dados cadastrados com sucesso.", "Aviso",
                        {
                            onHidden: function () {
                                event.target.disabled = false;
                                vm.back();
                            }
                        }
                    );
                })
                .catch(e => {
                    event.target.disabled = false;
                    vm.$toastr.error(e, 'Erro!', { timeOut: 8000 });
                });
        },
        updateEntity: function (event) {
            if (!this.$validator.isValid("#form1"))
            return;

            event.target.disabled = true;

            let vm = this;

            PrestadorController.update(vm.entity)
                .then(response => {
                    if (!response.data.success) {
                        vm.$toastr.error(response.data.error, 'Erro!', {
                            timeOut: 8000,
                            onHidden: function () {
                                event.target.disabled = false;
                            }
                        });
                        return;
                    }

                    vm.$toastr.success("Dados alterados com sucesso.", "Aviso",
                        {
                            onHidden: function () {
                                event.target.disabled = false;
                                vm.back();
                            }
                        });
                })
                .catch(e => {
                    event.target.disabled = false;
                    vm.$toastr.error(e, 'Erro!', { timeOut: 8000 });
                });
        },
        deleteEntity: function (event) {
            event.target.disabled = true;

            let vm = this;

            vm.$dialogs.confirm({
                title: 'Confirmar Exclusão!',
                content: 'Deseja realmente excluir estes dados?',
                icon: 'fa fa-exclamation-triangle ',
                type: 'red',
                buttons: {
                    confirm: {
                        text: 'Confirmar',
                        btnClass: 'btn-red',
                        action: function () {
                            event.target.disabled = true;

                            PrestadorController.delete(vm.entity)
                                .then(response => {

                                    if (!response.data.success) {
                                        vm.$toastr.error(response.data.error, 'Erro!', {
                                            timeOut: 8000,
                                            onHidden: function () {
                                                event.target.disabled = false;
                                            }
                                        });
                                        return;
                                    }

                                    vm.$toastr.success("Dados excluídos com sucesso.", "Aviso",
                                        {
                                            onHidden: function () {
                                                vm.back();
                                            }
                                        }
                                    );
                                })
                                .catch(e => {
                                    vm.$toastr.error(e, 'Erro!', { timeOut: 8000 });
                                    event.target.disabled = false;
                                });
                        }
                    },
                    close: {
                        text: 'Cancelar'
                    }
                }
            });
            event.target.disabled = false;
        },
        back: function () {
            this.$router.push({ name: "list-prestador" });
        }
    }
};
</script>

<style scoped>
</style>